import React, { memo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Box,
  Tooltip,
  IconButton,
  Grid,
  Typography,
  Button,
  NativeSelect,
  InputLabel,
  TextField,
  InputAdornment,
  FormControl,
  CircularProgress,
  Card,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import configServ from "../../services/config";
import CheckAndReturn from "../../utility/CheckAndReturn";
import DesktopView from "../../Components/views/DesktopView";
import MobileView from "../../Components/views/MobileView";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Swal from "sweetalert2";
//import AddLineItem from '../../masterEntry/ItemEditOptions/AddLineItem';

//FUNCTION
const BatchTable = ({ handleEdit, isChanged, pagination = true }) => {
  //#region code
  const { company_id } = useSelector((state) => state.GlobalVariables);
  const rowsPerPageOptions = [5, 10, 20, 50];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
  const [itemList, setItemList] = useState([]);
  // [filterItemList, setFilterItemList] = useState([]);
  const [searchBy, setSearchBy] = useState("item_name");
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  //const [openGenerateLineItems, setOpenGenerateLineItems] = useState(false);
  //const [lineItem, setLineItem] = useState({});

  useEffect(() => {
    fetchItemList();
  }, [isChanged, page, rowsPerPage, search]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const fetchItemList = async () => {
    setLoading(true);
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: searchBy,
        search: search,
        per_page: rowsPerPage,
        page: page,
      };
      const res = await configServ.getAllBatchs(dataToSend);
      if (res.status) {
        setItemList(res.data);
        setCount(res.total);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const headers = [
    "Exam Name",
    "Exam Code",
    "Date",
    "Time",
    // "First Stage",
    "Status",
    "Action",
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, count - page * rowsPerPage);

  // const paginatedData = pagination
  //     ? filterItemList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  //     : filterItemList;

  const headerCellStyle = {
    fontSize: 14, // Adjust the font size as needed
    fontWeight: "bold",
    backgroundColor: "black", // Set the header background color to blue
    color: "white",
    padding: 5,
    textAlign: "center",
  };

  const evenRowStyle = {
    background: "#f5f5f5",
  };

  const oddRowStyle = {
    background: "white",
  };

  const rowStyle = {
    "&:hover": {
      background: "#f1f9fe",
    },
  };

  const cellStyle = {
    py: 0,
    my: 0,
    textAlign: "center",
  };

  // const FetchLocationName = ({ id }) => {
  //     const [loc, setLoc] = useState()

  //     useEffect(() => {
  //         if (id !== 0) {
  //             locName()
  //         }
  //     }, [])

  //     const locName = async () => {
  //         try {
  //             const result = await configServ.getLocationById({ "id": id })
  //             setLoc(result.location_name)
  //         } catch (err) {
  //             console.log(err)
  //         }
  //     }

  //     return (
  //         <TableCell>{loc || 'N/A'}</TableCell>
  //     )
  // }

  const handleSearchBy = (event) => {
    try {
      setSearchBy(event.target.value);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearch = (event) => {
    try {
      const data = event.target.value;
      if (data === "") {
        setSearch(null);
      } else {
        setSearch(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const handleOpenLineItems = () => {
  //     setOpenGenerateLineItems(true);
  // };

  // const handleCloseLineItems = () => {
  //     setOpenGenerateLineItems(false);
  // };

  // const handleLineItems = (params) => {
  //     try {
  //         setLineItem(params);
  //         handleOpenLineItems();
  //     }
  //     catch (e) {
  //         console.log(e);
  //     }
  // }

  //#endregion

  const formatTime12Hour = (time) => {
  if (!time) return "";

  const [hour, minute] = time.split(":");
  return new Date(0, 0, 0, hour, minute)
    .toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });
};


  return (
    <>
      <Grid
        container
        alignItems="flex-end"
        justifyContent="flex-start"
        sx={{ py: 1 }}
        spacing={1}
        direction={"row"}
      >
        <Grid item xs={12} md={6} justifyContent={"flex-start"}>
          <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
            Batch List:{count}
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Box sx={{ minWidth: 120, marginLeft: "10px" }}>
            <FormControl fullWidth>
              <InputLabel variant="standard" htmlFor="uncontrolled-native">
                Search By
              </InputLabel>
              <NativeSelect
                defaultValue={"contact_name"}
                onChange={handleSearchBy}
                inputProps={{
                  name: "searchBy",
                  id: "uncontrolled-native",
                }}
              >
                <option value={"item_name"}>Batch Name</option>
                <option value={"item_code"}>Batch Code</option>
                {/* <option value={'location_name'}>Location</option> */}
              </NativeSelect>
            </FormControl>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
          mr={{ xs: 0, md: 0 }}
          justifyContent={"flex-end"}
        >
          <TextField
            id="outlined-basic"
            size="small"
            fullWidth
            placeholder="search"
            variant="outlined"
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ fill: "grey" }} />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>

      <DesktopView>
        <TableContainer component={Paper} sx={{ px: 1 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={headerCellStyle}>Sr. No.</TableCell>
                {headers.map((header, index) => (
                  <TableCell key={index} style={headerCellStyle}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={headers.length + 1} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : itemList.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={headers.length + 1}
                    align="center"
                    sx={{ color: "red" }}
                  >
                    <b>No Data Found</b>
                  </TableCell>
                </TableRow>
              ) : (
                itemList.map((row, rowIndex) => (
                  <TableRow
                    key={rowIndex}
                    sx={{
                      ...rowStyle,
                      ...(rowIndex % 2 === 0 ? evenRowStyle : oddRowStyle),
                    }}
                  >
                    <TableCell sx={cellStyle}>
                      {page * rowsPerPage + rowIndex + 1}
                    </TableCell>
                    <TableCell sx={cellStyle}>{row.item_name}</TableCell>
                    <TableCell sx={cellStyle}>{row.item_code}</TableCell>
                    <TableCell sx={cellStyle}>
                      {CheckAndReturn.transformToDate2(row.start_date)} -{" "}
                      {CheckAndReturn.transformToDate2(row.end_date)}
                    </TableCell>
                    <TableCell sx={cellStyle}>
                     {formatTime12Hour(row.start_time)} - {formatTime12Hour(row.end_time)}
                    </TableCell>
                    <TableCell sx={cellStyle}>
                      {row.status === 1 ? (
                        <CheckCircleIcon color="success" />
                      ) : (
                        <CancelIcon color="error" />
                      )}
                    </TableCell>
                    <TableCell sx={cellStyle}>
                      <Tooltip title="Edit" placement="top" arrow>
                        <IconButton
                          onClick={() => {
                            handleEdit(row);
                            scrollToTop();
                          }}
                          sx={{ "&hover": { backgroundColor: "#99999955" } }}
                        >
                          <EditIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="View" placement="top" arrow>
                        <IconButton
                          onClick={() => {
                            Swal.fire({
                              title: "Batch Days",
                              html: row.days
                                ? row.days.split(",").join(", ")
                                : "No days available",
                              icon: "info",
                              confirmButtonText: "OK",
                            });
                          }}
                          sx={{ "&:hover": { backgroundColor: "#99999955" } }}
                        >
                          <VisibilityIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
          {pagination && (
            <TablePagination
              rowsPerPageOptions={rowsPerPageOptions}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </TableContainer>
      </DesktopView>
      <MobileView>
        <Box mt={2}>
          {loading ? (
            <Box textAlign="center" mt={2}>
              <CircularProgress />
            </Box>
          ) : itemList.length === 0 ? (
            <Typography textAlign="center" color="red" mt={2}>
              <b>No Data Found</b>
            </Typography>
          ) : (
            itemList.map((row, rowIndex) => (
              <Card key={rowIndex} sx={{ mb: 2, p: 2 }}>
                <Typography variant="subtitle1">
                  {page * rowsPerPage + rowIndex + 1}. {row.item_name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Code: {row.item_code}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Start - End Date: {CheckAndReturn.transformToDate2(row.start_date)} - {CheckAndReturn.transformToDate2(row.end_date)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Start-End Time:   {formatTime12Hour(row.start_time)} - {formatTime12Hour(row.end_time)}
                </Typography>
                <Box display="flex" alignItems="center" mt={1}>
                  {row.status === 1 ? (
                    <CheckCircleIcon color="success" />
                  ) : (
                    <CancelIcon color="error" />
                  )}
                  <Box ml="auto">
                    <IconButton
                      onClick={() => {
                        handleEdit(row);
                        scrollToTop();
                      }}
                    >
                      <EditIcon color="primary" />
                    </IconButton>

                    <IconButton
                      onClick={() => {
                        Swal.fire({
                          title: "Batch Days",
                          html: row.days
                            ? row.days.split(",").join(", ")
                            : "No days available",
                          icon: "info",
                          confirmButtonText: "OK",
                        });
                      }}
                      sx={{ "&:hover": { backgroundColor: "#99999955" } }}
                    >
                      <VisibilityIcon color="primary" />
                    </IconButton>
                  </Box>
                </Box>
              </Card>
            ))
          )}
          {pagination && (
            <TablePagination
              rowsPerPageOptions={rowsPerPageOptions}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Box>
      </MobileView>
    </>
  );
};

export default memo(BatchTable);
